import {KTSVG} from '../../../helpers'
import React, {FC, useEffect, useState} from 'react'
import {useNotifications} from '../../../../app/@contexts'
import {CapitalizeFirstLetter} from '../../../../app/features'

const Toast: FC = () => {

    const {toast: {type, text: {message, title}}, setToast} = useNotifications()
    const [visible, setVisible] = useState<boolean>(!!type)

    useEffect(() => {
        if (type) {
            setVisible(true)

            const timer = setTimeout(() => {
                setVisible(false)

                setTimeout(() => {
                    setToast((prev) => ({
                        ...prev,
                        type: '',
                    }))
                }, 1000)
            }, 3000)

            return () => clearTimeout(timer)
        }
    }, [type, setToast])


    const translateX = visible ? (type === 'success' || type === 'error' ? -10 : 100) : 100
    const scale = visible ? (type === '' ? 0 : 1) : 0
    const opacity = visible ? (type === '' ? 0 : 1) : 0

    const colors = {
        linearGradient: type === 'success' ? 'linear-gradient(90deg, #e8fff3 30%, #aefcd4 100%)' : 'linear-gradient(90deg, #fff5f8 30%, #fcbfd1 100%)',
        className: type === 'success' ? 'success' : type === 'error' ? 'danger' : '',
        icon: type === 'success' ? '/general/gen048.svg' : type === 'error' ? '/general/gen050.svg' : '',
    }

    return (
        <>
            <div className="card"
                 style={{
                     background: colors.linearGradient,
                     position: 'fixed',
                     right: 0,
                     top: 0,
                     transform: `translateX(${translateX}%) translateY(65px) scale(${scale}`,
                     opacity,
                     zIndex: 9999,
                     backdropFilter: 'blur(10px)',
                     minWidth: 350,
                     maxWidth: 500,
                     transition: 'transform .3s ease, opacity .2s ease',
                 }}
            >
                <div className="card-body p-2 p-sm-3">
                    <div className="d-flex flex-wrap flex-sm-nowrap">
                        <div
                            className={`d-flex flex-center flex-shrink-0 rounded w-30px h-30px w-sm-40px h-sm-40px me-5 border border-1 border-${colors.className}`}
                            // style={{background: `${colors.bg}99`}}>
                            style={{background: `#ffffff80`}}>
                            <KTSVG path={`/media/icons/duotune${colors.icon}`}
                                   className={`svg-icon svg-icon-2x svg-icon-${colors.className}`}
                            />
                        </div>
                        <div className="d-flex flex-column">
                            <div className="d-flex align-items-center mb-1">
                                <span className={`text-${colors.className} fs-6 fs-sm-5 fw-bolder`}>{title}</span>
                            </div>
                            <div className="d-flex flex-wrap fw-bold fs-7 fs-sm-8 text-gray-700">{CapitalizeFirstLetter(message)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export {Toast}
